
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";

  @Component({})
  export default class ModalTabs extends Vue {
    @Prop({ type: Array, required: true}) readonly tabs!: string[];
    @Prop({ type: Number, default: 0 }) readonly initialTabIndex!: number;

    selectedTabIndex: number = 0;

    created() {
      this.selectedTabIndex = this.initialTabIndex;
    }

    @Watch("initialTabIndex")
    onInitialTabIndexChanged(newIndex: number): void {
      this.selectedTabIndex = newIndex;
    }

    selectedTabStyle(index: number): object {
      return {
        "border-secondary-black text-default-black" : this.selectedTabIndex === index,
      };
    }

    updateTabIndex(index: number): void {
      this.selectedTabIndex = index;
      this.$emit("tabIndexUpdated", index)
    }
  }
